import React, { useState, useEffect, ReactElement } from "react";

import { useSelector, shallowEqual } from "react-redux";
import { useHistory } from "react-router-dom";

// Components
import Intro from "../../components/microsite/intro/intro.component";

import Agenda from "../../components/microsite/agenda/agenda.component";
import Speakers from "../../components/microsite/speakers/speakers.component";
import Documents from "../../components/documents/documents.component";
import Sponsors from "../../components/microsite/sponsors/sponsors.component";
import Codesnippet from "../../components/microsite/codesnippet/codesnippet.component";

import { MICROSITE_TYPE } from "../../utils/constants";

import { onSnapshotMicrositeLayout } from "../../apis/firebase";

let snapshotRef = null;

const Home = (): ReactElement => {
  const { generalSettings } = useSelector(
    ({ generalSettings }) => ({
      generalSettings,
    }),
    shallowEqual
  );

  let history = useHistory();

  const [isLoading, setIsLoading] = useState(true);
  const [widgetList, setWidgetList] = useState([]);

  useEffect(() => {
    if (
      generalSettings.hasOwnProperty("micrositeEnabled") &&
      !generalSettings.micrositeEnabled
    ) {
      //   window.location.href = "/live";
      history.push("/live");
    } else if (
      generalSettings.hasOwnProperty("micrositeEnabled") &&
      generalSettings.micrositeEnabled
    ) {
      setIsLoading(false);
    }

    snapshotRef = onSnapshotMicrositeLayout((dt) => {
      setWidgetList(dt);

      setIsLoading(false);
    });

    return () => !!snapshotRef && snapshotRef();
  }, [generalSettings]);

  const loadWidget = (data, idx) => {
    switch (data.type) {
      case MICROSITE_TYPE.INTRODUCTION:
        return <Intro data={data} idx={idx}></Intro>;
        break;
      case MICROSITE_TYPE.AGENDA:
        return <Agenda data={data} idx={idx}></Agenda>;
        break;
      case MICROSITE_TYPE.DOCUMENTS:
        return <Documents data={data} idx={idx}></Documents>;
        break;
      case MICROSITE_TYPE.SPEAKERS:
        return <Speakers data={data} idx={idx}></Speakers>;
        break;
      case MICROSITE_TYPE.SPONSORS:
        return <Sponsors data={data} idx={idx}></Sponsors>;
        break;
      case MICROSITE_TYPE.CODESNIPPET:
        return <Codesnippet data={data} idx={idx}></Codesnippet>;
        break;
      default:
        return <></>;
    }
  };

  return (
    <>
      {!isLoading && (
        <div className="container mb-5">
          {widgetList.length > 0 &&
            widgetList.map((d, idx) => (
              <React.Fragment key={idx}>{loadWidget(d, idx)}</React.Fragment>
            ))}
        </div>
      )}
    </>
  );
};

export default Home;
